const Cart = () => {
    return(
        <div>Hello From Cart</div>
    )
}

export default Cart